import { useContext, useState } from "react"
import { SidePopupLayout } from "src/component/SidePopupLayout"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, Form, FormGroup, FormGroupWithIcon, GridContainer, Icon, ScreenTitle, Switch } from "src/style"
import MastercardLogo from 'src/assets/img/mastercard-logo.svg'
import { FiChevronDown } from "react-icons/fi"
import { SavedCards, TxPinVerification } from "src/component"


export const FundWithCard: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [input, setInput] = useState({sourceAccount: '', amount: '', shouldSaveCard: false, cardDetails: {}})
    const [view, setView] = useState('fund-with-card')

    const handleInput = (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => setInput({...input, [e.target.name]: e.target.value})

    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        setView('pin')
    }

    async function handleSubmit() {
        notifier.show('Account Funded', null, 'success')
        close()
    }

    return (
        <>
            { view === 'fund-with-card' &&
                <SidePopupLayout close={close}>
                    <ScreenTitle textSize="2.2" fontWeight="700">Fund with Card</ScreenTitle>
                    <CustomContainer topMargin='2.5'>
                        <Form onSubmit={handleProceed}>
                            <FormGroup>
                                <label>Amount</label>
                                <input 
                                    placeholder='Enter Amount' 
                                    type='number'
                                    name='amount'
                                    value={input.amount}
                                    onChange={handleInput}
                                    autoComplete="off"
                                    //required
                                />
                            </FormGroup>
                            <AppSpan 
                                cursor="pointer" fontWeight="700" color="#0D968F" 
                                hoverColor="#667085"
                                onClick={() => setView('saved-cards')}
                            >
                                Use Saved Card
                            </AppSpan>
                            <FlexColumn 
                                minHeight="12.7" borderColor="#EAECF0" radius="0.8"
                                padding="2" topPadding="1" bottomPadding="1"
                                justifyContent="space-between" topMargin="2"
                            >
                                <FlexRow gap="1.5" justifyContent="space-between" alignItems="flex-start">
                                    <AppSpan textSize="2" fontWeight="700">XXXX  XXXX XXXX XXXX</AppSpan>
                                    <CustomContainer width='3.46' height='2.4' borderColor="#F2F4F7" radius="0.4">
                                        <Icon src={MastercardLogo} minWidth='100' /> 
                                    </CustomContainer>
                                </FlexRow>
                                <FlexRow gap="1.5" justifyContent="space-between" topMargin="1.5">
                                    <GridContainer alignItems="start" width="auto" sizeUnit="">
                                        <AppSpan textSize="1" fontWeight="300">MONTH / YEAR</AppSpan>
                                        <AppText textSize="1.6">12/22</AppText>
                                    </GridContainer>
                                    <GridContainer alignItems="end" width="auto" sizeUnit="">
                                        <AppSpan textSize="1" fontWeight="300">CVV</AppSpan>
                                        <AppText textSize="1.6">XXX</AppText>
                                    </GridContainer>
                                </FlexRow>
                            </FlexColumn>
                            <FlexRow  topMargin='2' bottomMargin='2'>
                                <Switch
                                    radius='1.17' bgColor='#F2F4F7' 
                                    checkedBgColor='#0D968F' checkedSliderBgColor="#ffffff"
                                >
                                    <input 
                                        type="checkbox" 
                                        checked={input.shouldSaveCard}
                                        onChange={(e) => setInput({...input, shouldSaveCard: e.target.checked})} />
                                    <div ></div>
                                    <span></span>
                                </Switch>
                                <AppText fontWeight="600" color="#344054" leftMargin="1">
                                    Save Card
                                </AppText>
                            </FlexRow>
                            <FormGroupWithIcon>
                                <label>Source Account</label>
                                <div className="input-with-icon">
                                    <select 
                                        placeholder="Source Account"
                                        name='sourceAccount'
                                        value={input.sourceAccount}
                                        style={{color: input.sourceAccount ? '#000000' : '#667085'}}
                                        onChange={handleInput}
                                        //required
                                    >
                                        <option value="">Select Source Account</option>
                                        <option value="2236728192">Qore - 2236728192</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <FlexRow justifyContent='flex-end' topMargin='2.5'>
                                <Button 
                                    width='8.8' height='4' 
                                    borderColor='#0D968F' hoverBgColor='#fff' 
                                    hoverColor='#0D968F' titleSize='1.4'
                                >
                                    Proceed
                                </Button>
                            </FlexRow>
                        </Form>
                    </CustomContainer>
                </SidePopupLayout>
            }
            { view === 'pin' &&
                <TxPinVerification
                    title='Enter OTP'
                    close={close}
                    next={handleSubmit} 
                />
            }
            { view === 'saved-cards' &&
                <SavedCards 
                    close={() => setView('fund-with-card')}
                    handleSelectedCard={(cardDetails: any) => setInput({...input, cardDetails})}
                />
            }
        </>
    )
}